import React, { useRef } from 'react'
import { CSSTransition } from 'react-transition-group'
import { Alert, Snackbar, Typography } from '@mui/material'
import Image from 'next/image'

import SuccessSvg from '#/assets/svg/success.svg?react'
import { getDeviceType } from '#/shared'

import type { Variant } from '../lib/hooks/use-show-data'
import { useShowDataStore } from '../lib/hooks/use-show-data'

import styles from './error.module.scss'

export interface IError {
	handleClose?: () => void
}

const ErrorIcon = () => {
	return <Image src='/error2.svg' alt='' width={20} height={20} className={styles.errorIcon} />
}

const WarningIcon = () => {
	return (
		<Image src='/svg/important.svg' alt='' width={20} height={20} className={styles.warningIcon} />
	)
}

const ALERT_CONFIG: Record<
	Variant,
	{
		icon: React.ReactNode
		border: string
	}
> = {
	error: {
		icon: <ErrorIcon />,
		border: '1px solid #F15179',
	},
	success: {
		icon: <SuccessSvg width={20} height={20} color='#5ef151' />,
		border: '1px solid #5ef151',
	},
	warning: {
		icon: <WarningIcon />,
		border: '1px solid #FFB800',
	},
}

export const Error: React.FC<IError> = ({ handleClose }) => {
	const { message, variant, isOpened } = useShowDataStore()
	const nodeRef = useRef(null)
	const isDesktop = getDeviceType() === 'desktop'
	const { icon, border } = ALERT_CONFIG[variant]

	return (
		<CSSTransition nodeRef={nodeRef} in={isOpened} timeout={400} unmountOnExit classNames='my-node'>
			<Snackbar
				className={isDesktop ? styles.errorSnackbarDesktop : styles.errorSnackbar}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				open={isOpened}
				onClose={handleClose}
			>
				<Alert
					ref={nodeRef}
					icon={icon}
					severity='error'
					sx={{
						backgroundColor: '#404040',
						border,
						color: '#C7C7C7',
						borderRadius: '12px',
					}}
				>
					<Typography sx={{ fontSize: '17px' }}>{message}</Typography>
				</Alert>
			</Snackbar>
		</CSSTransition>
	)
}
